module.exports = __webpack_public_path__ + "media/images/btn-arrow-dark-right-91e7d72e4cf147c5bad202eb5e1f2333.svg";